import './MatchDate.css'

const MatchDate = ({ date }) => (
  <div className="matchDate">
    <p>{date}</p>
  </div>
)

export default MatchDate
